import React, { useState } from 'react';
import styles from './Timer.module.css';

export default function Timer({ onComplete }) {
  const [isRunning, setIsRunning] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  // Format time for display
  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  // Convert decimal seconds to HH:MM time format
  const secondsToTimeString = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  };

  const handleStart = () => {
    setStartTime(new Date());
    setIsRunning(true);
  };

  const handleStop = () => {
    setIsRunning(false);
  };

  const handleReset = () => {
    setIsRunning(false);
    setStartTime(null);
    setElapsedSeconds(0);
  };

  const handleComplete = () => {
    if (onComplete) {
      onComplete({
        elapsedSeconds,
        displayTime: formatTime(elapsedSeconds),
        timeString: secondsToTimeString(elapsedSeconds),
      });
    }
    handleReset();
  };

  // Update elapsed time every second
  React.useEffect(() => {
    let interval;
    if (isRunning && startTime) {
      interval = setInterval(() => {
        const now = new Date();
        const diff = Math.floor((now - startTime) / 1000) + elapsedSeconds;
        setElapsedSeconds(diff);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isRunning, startTime, elapsedSeconds]);

  return (
    <div className={styles.timer}>
      <div className={styles.display}>{formatTime(elapsedSeconds)}</div>
      <div className={styles.controls}>
        {!isRunning ? (
          <button className={styles.btn} onClick={handleStart}>
            Start
          </button>
        ) : (
          <button className={styles.btn} onClick={handleStop}>
            Stop
          </button>
        )}
        <button className={styles.btn} onClick={handleReset}>
          Reset
        </button>
        <button className={styles.btnSuccess} onClick={handleComplete}>
          Use Time
        </button>
      </div>
    </div>
  );
}
